import React from 'react';
import Container from 'container';
import Headline from 'headline';
import Button from 'button';
import { useHeroImage } from '../../../hooks/useHeroImage';
import s from './hero.module.scss';

export default function HeroLp({
  image,
  mobile_image,
  first_title,
  second_title,
  first_button,
  second_button
}) {
  const { heroImage } = useHeroImage({ image, mobile_image });
  return (
    <Container
      image={heroImage}
      className={`${s.root}`}
    >
      <div className={s.wrapper}>
        {/* Headlines */}
        <div className={s.headlines}>
          <Headline h1 left black html={first_title} />

          <Headline h1 left black html={second_title} />
        </div>

        {/* Buttons */}
        <div className={s.buttons}>
          <Button small href={first_button.url}>{first_button.title}</Button>

          <Button small href={second_button.url}>{second_button.title}</Button>
        </div>
      </div>
    </Container>
  );
}
